import React from "react";
import moment from "moment";
import {Swiper, SwiperSlide} from "swiper/react";
import {TextField} from "@mui/material";

export default function SlideDatepicker(props) {
  const slideSwiper = (nextFg) => {
    if (props.ymdFg && props.state.data !== undefined && new Date(props.state.date).toLocaleDateString() !== "Invalid Date") {
      props.setState({...props.state, date: nextFg ? moment(props.state.date).add(1, "d").format("yyyy-MM-DD") : moment(props.state.date).subtract(1, "d").format("yyyy-MM-DD"), stopRender: true});
    } else if (props.state.data !== undefined && new Date(props.state.date + "-01").toLocaleDateString() !== "Invalid Date") {
      props.setState({...props.state, date: nextFg ? moment(props.state.date).add(1, "M").format("yyyy-MM") : moment(props.state.date).subtract(1, "M").format("yyyy-MM"), stopRender: true});
    }
  };

  return (
    <Swiper
      allowTouchMove = {!(props.disabled)}
      loop = {true}
      runCallbacksOnInit = {false}
      onSlideNextTransitionStart = {() => slideSwiper(true)}
      onSlidePrevTransitionStart = {() => slideSwiper(false)}
      resistance = {false}
      threshold = {20}
    >
      <SwiperSlide>
        <TextField
          className = "bgcolor-white"
          disabled = {props.disabled}
          onChange = {(e) => props.setState({...props.state, date: e.target.value, stopRender: true})}
          sx = {{width: "60%"}}
          type = {props.ymdFg ? "date" : "month"}
          value = {props.state.date}
        />
      </SwiperSlide>
    </Swiper>
  );
};
